export const state = {
  cards: {}
}

export const getters = {
  cards: state => state.cards
}

export const mutations = {
  SET_CARDS: (state, cards) => {
    state.cards = cards
  },
  INCREMENT_CARD_COUNT: (state, { cardId, cardType }) => {
    // const card = state.cards.find(card => card.id === cardId)
    // if (cardType === 'adult') {
    //   card.adultCardCount++
    // } else if (cardType === 'child') {
    //   card.childCardCount++
    // }
    state.cards.forEach(card => {
      if (cardType === 'adult') {
        card.adultCardCount++
      } else if (cardType === 'child') {
        card.childCardCount++
      }
    })
  },
  DECREMENT_CARD_COUNT: (state, { cardId, cardType }) => {
    // const card = state.cards.find(card => card.id === cardId)
    // if (cardType === 'adult') {
    //   if (card.adultCardCount > 0) {
    //     card.adultCardCount--
    //   }
    // } else if (cardType === 'child') {
    //   if (card.childCardCount > 0) {
    //     card.childCardCount--
    //   }
    // }
    state.cards.forEach(card => {
      if (cardType === 'adult') {
        if (card.adultCardCount > 0) {
          card.adultCardCount--
        }
      } else if (cardType === 'child') {
        if (card.childCardCount > 0) {
          card.childCardCount--
        }
      }
    })
  }
}

export const actions = {
  setCardsCalculatorData: ({ commit, rootGetters }) => {
    // const prices = rootGetters['cards/cardPrices']
    const cardsData = rootGetters['cards/cards'].map(card => {
      return {
        id: card.id,
        name: card.name,
        days: parseInt(card.name.default[0]), // '2 DAY PASS' => 2, temporary fix until we get ccm
        priceAdult: card.products[0].price,
        priceChild: card.products[1].price,
        priceAdultFixedCZK: +card.products[0].price_czk,
        priceChildFixedCZK: +card.products[1].price_czk,
        adultCardCount: 0,
        childCardCount: 0
      }
    })
    commit('SET_CARDS', cardsData)
  }
}
